import { Box, Theme } from '@mui/material'
import styled from 'styled-components'

export const SettingsSelectionListItemContainer = styled(Box)<{
  isselected: string
  theme: Theme
}>`
  height: 75px;
  padding: 15px;
  border-radius: 10px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: ${({ isselected, theme }) =>
    isselected === 'true'
      ? theme.palette.primary.main
      : theme.palette.secondary.light};

  p {
    font-size: 15px;
    font-weight: ${({ isselected }) => (isselected === 'true' ? 700 : 300)};
    color: ${({ isselected, theme }) =>
      isselected === 'true'
        ? theme.palette.common.white
        : theme.palette.common.black};
  }
`
